module.exports = __webpack_public_path__ + "img/img_65.725862be.png";